export const failureHash = {
    ACTION_BLOCKED: "API__EP__SOCIAL_PAGE_GROUP__ACTION_BLOCKED",
    ORGANIZATION_TEMPORARILY_INACTIVE: "API__EP__SOCIAL_PAGE_GROUP__ORGANIZATION_TEMPORARILY_INACTIVE",
    SOCIAL_PAGE_GROUPS_LIMIT_HIT: "API__EP__SOCIAL_PAGE_GROUP__SOCIAL_PAGE_GROUPS_LIMIT_HIT",
    SOCIAL_PAGE_GROUP_NAME_ALREADY_EXISTS: "API__EP__SOCIAL_PAGE_GROUP__SOCIAL_PAGE_GROUP_NAME_ALREADY_EXISTS",
    UNKNOWN: "API__EP__SOCIAL_PAGE_GROUP__UNKNOWN", // Unknown error has occurred.
};
//# sourceMappingURL=social_page_group.static.js.map